module.exports = __webpack_public_path__ + "assets/img/ban9.80775841.png";